import React, { useState, useRef, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Container, Grid, MenuItem, Paper } from '@material-ui/core';
import ReactTable from 'Components/ReactTable/ReactTable';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { LOGOUT } from 'ConstComponents';
import { UPITransferClickPay as UPI_TRANSFER } from 'Components/Api/UPITransfer';
import { SelectSuccessUPITransferTransaction as SUCCESS_TRANSACTION } from 'Components/Api/TransactionReportAPI';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { SelectForReceipt as TRANSACTION_RECEIPT } from 'Components/Api/TransactionReportAPI';
import { UPITransferPrint } from 'Components/Print/UPITransferPrint';
import Divider from '@material-ui/core/Divider';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { UPITRANSFER_CODE } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import PayIcon from 'Components/SvgButtons/PayIcon';
import { Last10RechargeReport } from 'Pages/InnerPages/Report/Last10RechargeReport';
import AsyncOperatorAutoComplete from 'Components/Inputes/AsyncOperatorAutoComplete';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { SelectByOperatorID as BBPS_CONFIG_SELECT_BY_OPERATORID } from 'Components/Api/BBPSConfigurationAPI';

const CustomContainer = HOCLoader(Container);

export const ClickPayUPITransfer = () => {
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const [transactions, setTransactions] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [confirmAlertMessage, setConfirmAlertMessage] = useState('');
    const [serviceCode, setserviceCode] = useState(UPITRANSFER_CODE);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [status, setStatus] = useState('PROCESS');
    const [Operator, setOperator] = useState([]);

    const [isPrintOpen, setIsPrintOpen] = useState(false);
    const [isReadOnly, setReadOnly] = useState(false);
    const [printData, setPrintData] = useState(null);

    const [BankExtensionConfig, setBankExtensionConfig] = useState([]);
    const formRef = useRef();

    const [OperatorDefault, setOperatorDefault] = useState({
        OperatorID: 0,
        OperatorName: 'Select Operator'
    });

    const [FormObj, setFormObj] = useState({
        ServiceID: UPITRANSFER_CODE,
        Operator: OperatorDefault,
        Amount: '',
        InWords: '',
        UPIID: '',
        BeneName: '',
        BankExtension: '',
        IsVerifyButton: false
    });

    const FormValidationSchema = Yup.object({
        Operator: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator')
            .shape({
                OperatorID: Yup.number()
                    .notOneOf([0], PLEASE_SELECT_VALID + 'operator')
                    .nullable(PLEASE_SELECT_VALID + 'operator')
                    .required(PLEASE_SELECT_VALID + 'operator')
            }),

        Amount: Yup.number().when(['IsVerifyButton'], {
            is: (IsVerify) => !IsVerify,
            then: Yup.number()
                .required(PLEASE_PROVIDE_VALID + 'amount')
                .min(0, PLEASE_PROVIDE_VALID + 'amount')
                .max(200000, PLEASE_PROVIDE_VALID + 'amount')
        }),

        BeneName: Yup.string().when(['IsVerifyButton'], {
            is: (IsVerify) => !IsVerify,
            then: Yup.string().required(PLEASE_PROVIDE_VALID + 'Bene Name')
        }),

        UPIID: Yup.string().required(PLEASE_PROVIDE_VALID + 'UPIID')
    });
    const selectOperatorConfig = async (OperatorID) => {
        var requestObj = {
            OperatorID: OperatorID
        };

        var request = JSON.stringify(requestObj);

        const response = await BBPS_CONFIG_SELECT_BY_OPERATORID(request);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);
        var ConfigList = JSON.parse(data[0].ConfigList);
        setBankExtensionConfig(ConfigList);
    };
    useEffect(() => {
        setLoading(true);
        createColumns();
        selectSuccessUPITransaction();
    }, []);

    useEffect(() => {
        setLoading(true);
        selectOperator(serviceCode);
    }, [serviceCode]);

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    const Print = (VendorID) => {
        SelectPrintData(VendorID);
    };

    const SelectPrintData = async (TransactionMasterID) => {
        var req = {
            ID: TransactionMasterID
        };
        var request = JSON.stringify(req);
        setLoading(true);
        const { isAuthorized, status, data } = await TRANSACTION_RECEIPT(
            request
        );
        setLoading(false);
        if (!isAuthorized) LOGOUT();
        var d = JSON.parse(data);
        setPrintData(d);
        setIsPrintOpen(true);
    };

    const selectSuccessUPITransaction = async () => {
        setLoading(true);
        setIsError(false);

        setTransactions([]);
        var response = await SUCCESS_TRANSACTION();
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        if (data.length < 0) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage('No transactions found');
            return;
        }

        setTransactions(data);
    };

    const UPIValidation = Yup.object({
        UPIID: Yup.string().required(PLEASE_PROVIDE_VALID + 'UPIID'),

        Operator: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator')
            .shape({
                OperatorID: Yup.number()
                    .notOneOf([0], PLEASE_SELECT_VALID + 'operator')
                    .nullable(PLEASE_SELECT_VALID + 'operator')
                    .required(PLEASE_SELECT_VALID + 'operator')
            })
    });

    const submitHandle = async (values, setFieldValue) => {
        setResponseMessage('');
        setIsError(false);

        let UPIID = values.UPIID;
        if (values.BankExtension && values.BankExtension.length >= 2) {
            UPIID = values.UPIID + values.BankExtension;
        }

        let DummyUPI = [];
        DummyUPI = UPIID.split('@');

        if (DummyUPI.length === 1) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage('Please, enter valid UPIID  ');
            return;
        }

        if (DummyUPI.length > 2) {
            UPIID = DummyUPI[0] + '@' + DummyUPI[1];
        }

        var RequestObj = {
            ServiceID: values.ServiceID,
            PaymentType: values.Operator.OperatorName,
            Amount: values.Amount,
            BeneName: values.BeneName,
            AccountNo: UPIID,
            OperatorID: values.Operator.OperatorID,
            UPIID: UPIID,
            IsVerify: false
        };

        let errorValidation = false;

        await UPIValidation.validate(values).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
        });

        if (errorValidation === true) {
            return;
        }

        let msg = '';

        msg = `Please confirm UPI details - \n\nUPI ID : ${UPIID}\nAmount : ${values.Amount}`;

        if (values.IsVerifyButton) {
            RequestObj = {
                ServiceID: values.ServiceID,
                PaymentType: values.Operator.OperatorName,
                OperatorID: values.Operator.OperatorID,
                AccountNo: UPIID,
                IFSC: values.IFSC,
                Amount: 1,
                IsVerify: true,
                BeneName: values.BeneName,
                UPIID: UPIID
            };

            msg = `Please confirm UPI details - \n\nUPI ID : ${UPIID}`;
        }

        setConfirmAlertMessage(msg);
        setConfirmAlertRequest(RequestObj);
        setIsAlertOpen(true);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'ServiceID',
            srno: true
        });
        columns.push({
            label: 'Name',
            name: 'BeneficiaryName'
        });

        columns.push({
            label: 'Type',
            name: 'PaymentType'
        });
        columns.push({
            label: 'VPA',
            name: 'AccountNo'
        });
        columns.push({
            label: 'Amount',
            name: 'Amount',
            length: 6,
            editableWithNumberOnly: true
        });

        columns.push({
            label: 'Transfer',
            name: 'BeneficiaryID',
            buttonTitle: 'Transfer',
            buttonWithTitle: true,
            callback: (value) => {
                TransferConfirmation(value);
            }
        });
        columns.push({
            label: 'OperatorID',
            name: 'OperatorID',
            hide: true
        });
        setMainColumns(columns);
    };

    const TransferValidation = Yup.object({
        AccountNo: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'account no')
            .min(7, PLEASE_PROVIDE_VALID + 'account no')
            .max(20, PLEASE_PROVIDE_VALID + 'account no'),

        BeneName: Yup.string().required(PLEASE_PROVIDE_VALID + 'Bene Name'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(2, PLEASE_PROVIDE_VALID + 'amount')
            .max(500000, PLEASE_PROVIDE_VALID + 'amount')
    });

    const TransferConfirmation = async (values) => {
        let jsonObj = {
            ServiceID: UPITRANSFER_CODE,
            PaymentType: values[2],
            OperatorID: values[6],
            AccountNo: values[3],
            IFSC: values[6],
            Amount: values[4],
            BeneName: values[1],
            IsVerify: false,
            UPIID: values[3]
        };

        setConfirmAlertRequest(jsonObj);

        setIsError(false);
        var errorValidation = false;

        await TransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            selectSuccessUPITransaction();
            return;
        });

        if (errorValidation === true) return;

        let msg = `Please confirm UPI details - \n\n UPI ID : ${values[3]}\nAmount : ${values[4]}`;

        setConfirmAlertMessage(msg);
        setIsAlertOpen(true);
    };
    const OnOperatorChange = async (name, value, setFieldValue) => {
        setOperatorDefault({
            OperatorID: value.OperatorID,
            OperatorName: value.OperatorName
        });

        let OperatorID = value.OperatorID;
        setFieldValue(name, value);

        selectOperatorConfig(OperatorID);
    };

    const UPITransfer = async () => {
        setResponseMessage('');
        setIsError(false);

        var requestObj = JSON.stringify(confirmAlertRequest);

        setLoading(true);

        var response = await UPI_TRANSFER(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            let data = JSON.parse(response.data);
            setResponseMessage(data.Message);
            setIsError(true);
            return;
        }

        let dataSuccess = JSON.parse(response.data);

        setSeverity('success');
        setResponseMessage(dataSuccess.Message);
        setStatus(dataSuccess.Status);
        setResponseAlert(dataSuccess);
        setIsResponseAlertOpen(true);
        selectSuccessUPITransaction();
        reset(
            dataSuccess.BeneficiaryName,
            confirmAlertRequest.IsVerify,
            confirmAlertRequest.UPIID,
            confirmAlertRequest.PaymentType,
            confirmAlertRequest.OperatorID
        );
    };

    const reset = (
        BeneficiaryName,
        IsVerify,
        UPIID,
        PaymentType,
        OperatorID
    ) => {
        if (IsVerify === true) {
            setOperatorDefault({
                OperatorID: OperatorID,
                OperatorName: PaymentType
            });
            setFormObj({
                ...FormObj,
                UPIID: UPIID,
                BeneName: BeneficiaryName,
                Operator: OperatorDefault
            });
        }

        if (IsVerify === false) {
            setFormObj({
                ServiceID: UPITRANSFER_CODE,
                Operator: OperatorDefault,
                AccountNo: '',
                IFSC: '',
                Amount: '',
                UPIID: '',
                InWords: '',
                BeneName: BeneficiaryName,
                IsVerifyButton: false
            });
        }
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={FormObj}
            >
                {({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AsyncOperatorAutoComplete
                                                        }
                                                        defaultValue={
                                                            OperatorDefault
                                                        }
                                                        ImagePath={'Path'}
                                                        SubFieldName="OperatorID"
                                                        FieldName="Operator"
                                                        name="Operator"
                                                        options={Operator}
                                                        getOptionLabel={(
                                                            option
                                                        ) =>
                                                            option.OperatorName
                                                        }
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.OperatorName ===
                                                            value.OperatorName
                                                        }
                                                        textFieldProps={{
                                                            label:
                                                                'Select Operator'
                                                        }}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            OnOperatorChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={7}
                                                    lg={7}
                                                >
                                                    <MaterialTextField
                                                        label="UPI ID"
                                                        name="UPIID"
                                                        type="text"
                                                        length={100}
                                                        placeholder="UPI ID"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={5}
                                                    lg={5}
                                                >
                                                    <MaterialSelect
                                                        label="Bank"
                                                        name="BankExtension"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {}}
                                                        title="Bank"
                                                    >
                                                        <MenuItem
                                                            key="0"
                                                            value="0"
                                                        >
                                                            Bank
                                                        </MenuItem>
                                                        {BankExtensionConfig.map(
                                                            (Item) => (
                                                                <MenuItem
                                                                    key={
                                                                        Item.key
                                                                    }
                                                                    value={
                                                                        Item.value
                                                                    }
                                                                >
                                                                    {Item.value}
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </MaterialSelect>
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                ></Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <PrimaryButton
                                                        title="Verify"
                                                        endIcon={<PayIcon />}
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'IsVerifyButton',
                                                                true
                                                            );
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="Name"
                                                        name="BeneName"
                                                        type="text"
                                                        length={20}
                                                        placeholder="Name"
                                                        readOnly={isReadOnly}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialCurrency
                                                        name="Amount"
                                                        label="Amount"
                                                        placeholder="Amount"
                                                        max={500000}
                                                        onCustomCallback={(
                                                            value
                                                        ) => {
                                                            setFieldValue(
                                                                'InWords',
                                                                NumberToWord(
                                                                    value
                                                                )
                                                            );
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="In words"
                                                        name="InWords"
                                                        type="text"
                                                        readOnly={true}
                                                        placeholder="InWords"
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                ></Grid>
                                            </Grid>

                                            <Divider
                                                variant="middle"
                                                className="rechdevider"
                                            />

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                spacing={2}
                                                container
                                                className={classes.footerGrid}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <SecondaryButton
                                                        type="reset"
                                                        variant="contained"
                                                        color="secondary"
                                                        title="Reset"
                                                        disabled={loading}
                                                        endIcon={<ResetIcon />}
                                                        onClick={(e) =>
                                                            reset(
                                                                '',
                                                                false,
                                                                '',
                                                                0
                                                            )
                                                        }
                                                    ></SecondaryButton>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="UPI Transfer"
                                                        endIcon={<PayIcon />}
                                                        disabled={loading}
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'IsVerifyButton',
                                                                false
                                                            );
                                                        }}
                                                    ></PrimaryButton>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Form>
                            </Grid>

                            <Grid item xs={12} sm={12} md={8} lg={8}>
                                <ReactTable
                                    data={transactions}
                                    columns={mainColumns}
                                    rowsPerPage={10}
                                />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            <Last10RechargeReport ServiceID={serviceCode} refreshRandom={1} />
            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="UPI Transfer Confirmation"
                    message={confirmAlertMessage}
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        UPITransfer(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    isPrint={true}
                    title={status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                    PrintButtonClick={() => {
                        Print(ResponseAlert.VendorID);
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
            {isPrintOpen ? (
                <UPITransferPrint
                    isOpen={isPrintOpen}
                    title="UPI Transfer Print"
                    request={printData}
                    positiveButtonClick={() => {
                        setIsPrintOpen(false);
                    }}
                    negativeButtonClick={() => {
                        setIsPrintOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
